import { CustomElement, resolve } from 'aurelia';
import { AccountService } from '../../services';
import template from './email-optin-modal.html';
import './email-optin-modal.css';

// First-run email opt-in prompt. Renders only while AccountService.emailOptInOpen is set (a
// signed-in user who has not yet answered). Reuses the shared modal shell and lets the user
// choose whether Toy Calendar may email them, with optional per-channel toggles. All state and
// the submit behavior live in AccountService.
export class EmailOptInModalElement {
  readonly account: AccountService = resolve(AccountService);
}

export const EmailOptInModal = CustomElement.define({
  name: 'email-optin-modal',
  template
}, EmailOptInModalElement);
